// assets
import { IconListCheck,IconCategory, IconHelp, IconUserCheck, IconUsers, IconSettingsAutomation, IconTruck, IconClipboardList } from '@tabler/icons';



// constant
const icons = { IconListCheck,IconCategory, IconHelp,IconUserCheck, IconUsers, IconSettingsAutomation, IconTruck, IconClipboardList};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
  id: 'sample-docs-roadmap',
  type: 'group',
  children: [
    
    {
      id: 'Category',
      title: 'Category',
      type: 'item',
      url: '/category',
      icon: icons.IconCategory,
      breadcrumbs: true
    },
    {
      id: 'Buyer',
      title: 'Buyers',
      type: 'item',
      url: '/buyer',
      icon: icons.IconUserCheck,
      breadcrumbs: true
    },
    {
      id: 'Seller',
      title: 'Sellers',
      type: 'item',
      url: '/seller',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'Product',
      title: 'Product',
      type: 'item',
      url: '/product',
      icon: icons.IconListCheck,
      breadcrumbs: true
    },
    {
      id: 'Orders',
      title: 'Orders History',
      type: 'item',
      url: '/orderlist',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'Transporter',
      title: 'Transporter',
      type: 'item',
      url: '/transporter',
      icon: icons.IconTruck,
      breadcrumbs: true
    },
    {
      id: 'Orderer',
      title: 'Orderer',
      type: 'item',
      url: '/orderer',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'Reservation',
      title: 'Reservation History',
      type: 'item',
      url: '/reservationlist',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'Settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.IconSettingsAutomation,
      breadcrumbs: true
    },
    /*{
      id: 'documentation',
      title: 'Documentation',
      type: 'item',
      url: 'https://codedthemes.gitbook.io/berry/',
      icon: icons.IconHelp,
      external: true,
      target: true
    }*/
  ]
};

export default other; 
